import React, { useState } from 'react';
import { TrackNavBar } from '../components/NavBar/Index';
import Track from '../components/Track';
import axios from 'axios';

const URL = process.env.URL || 'https://usm-logistics-server.onrender.com/api/v1'


const TrackPage = () => {
    const [loading, setLoading] = useState(Boolean);
    const [trackingID, setTrackingID] = useState('');
    const [packageDetails, setPackageDetails] = useState({})

    const handleTrack = async () => {
        setLoading(true)
        try {
            let resp = await axios.get(`${URL}/track/get?trackingID=${trackingID}`);
            if (resp) {
                console.log(resp.data.data);
                setPackageDetails(resp.data.data);
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    return (
        <>
            <TrackNavBar trackingID={trackingID}
                setTrackingID={setTrackingID}
                handleTrack={handleTrack} />
            <Track loading={loading} packageDetails={packageDetails} />
        </>
    )
}

export default TrackPage;